/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnagrafeDTO } from './AnagrafeDTO';
import {
    AnagrafeDTOFromJSON,
    AnagrafeDTOFromJSONTyped,
    AnagrafeDTOToJSON,
} from './AnagrafeDTO';
import type { CicloDTO } from './CicloDTO';
import {
    CicloDTOFromJSON,
    CicloDTOFromJSONTyped,
    CicloDTOToJSON,
} from './CicloDTO';

/**
 * 
 * @export
 * @interface DocumentoMangimeDTO
 */
export interface DocumentoMangimeDTO {
    /**
     * 
     * @type {number}
     * @memberof DocumentoMangimeDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentoMangimeDTO
     */
    idCiclo?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentoMangimeDTO
     */
    idAnagrafeMittente?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentoMangimeDTO
     */
    idAnagrafeDestinatario?: number;
    /**
     * 
     * @type {Date}
     * @memberof DocumentoMangimeDTO
     */
    dataDocumento?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentoMangimeDTO
     */
    numeroDocumento?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentoMangimeDTO
     */
    dataOperazione?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentoMangimeDTO
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentoMangimeDTO
     */
    tipo?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentoMangimeDTO
     */
    idArxivar?: number | null;
    /**
     * 
     * @type {CicloDTO}
     * @memberof DocumentoMangimeDTO
     */
    ciclo?: CicloDTO;
    /**
     * 
     * @type {AnagrafeDTO}
     * @memberof DocumentoMangimeDTO
     */
    anagrafeMittente?: AnagrafeDTO;
    /**
     * 
     * @type {AnagrafeDTO}
     * @memberof DocumentoMangimeDTO
     */
    anagrafeDestinatario?: AnagrafeDTO;
    /**
     * 
     * @type {string}
     * @memberof DocumentoMangimeDTO
     */
    tipiMangime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentoMangimeDTO
     */
    kgConsegnati?: number | null;
}

/**
 * Check if a given object implements the DocumentoMangimeDTO interface.
 */
export function instanceOfDocumentoMangimeDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentoMangimeDTOFromJSON(json: any): DocumentoMangimeDTO {
    return DocumentoMangimeDTOFromJSONTyped(json, false);
}

export function DocumentoMangimeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentoMangimeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idCiclo': !exists(json, 'idCiclo') ? undefined : json['idCiclo'],
        'idAnagrafeMittente': !exists(json, 'idAnagrafeMittente') ? undefined : json['idAnagrafeMittente'],
        'idAnagrafeDestinatario': !exists(json, 'idAnagrafeDestinatario') ? undefined : json['idAnagrafeDestinatario'],
        'dataDocumento': !exists(json, 'dataDocumento') ? undefined : (new Date(json['dataDocumento'])),
        'numeroDocumento': !exists(json, 'numeroDocumento') ? undefined : json['numeroDocumento'],
        'dataOperazione': !exists(json, 'dataOperazione') ? undefined : (new Date(json['dataOperazione'])),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'tipo': !exists(json, 'tipo') ? undefined : json['tipo'],
        'idArxivar': !exists(json, 'idArxivar') ? undefined : json['idArxivar'],
        'ciclo': !exists(json, 'ciclo') ? undefined : CicloDTOFromJSON(json['ciclo']),
        'anagrafeMittente': !exists(json, 'anagrafeMittente') ? undefined : AnagrafeDTOFromJSON(json['anagrafeMittente']),
        'anagrafeDestinatario': !exists(json, 'anagrafeDestinatario') ? undefined : AnagrafeDTOFromJSON(json['anagrafeDestinatario']),
        'tipiMangime': !exists(json, 'tipiMangime') ? undefined : json['tipiMangime'],
        'kgConsegnati': !exists(json, 'kgConsegnati') ? undefined : json['kgConsegnati'],
    };
}

export function DocumentoMangimeDTOToJSON(value?: DocumentoMangimeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idCiclo': value.idCiclo,
        'idAnagrafeMittente': value.idAnagrafeMittente,
        'idAnagrafeDestinatario': value.idAnagrafeDestinatario,
        'dataDocumento': value.dataDocumento === undefined ? undefined : (value.dataDocumento.toISOString()),
        'numeroDocumento': value.numeroDocumento,
        'dataOperazione': value.dataOperazione === undefined ? undefined : (value.dataOperazione.toISOString()),
        'note': value.note,
        'tipo': value.tipo,
        'idArxivar': value.idArxivar,
        'ciclo': CicloDTOToJSON(value.ciclo),
        'anagrafeMittente': AnagrafeDTOToJSON(value.anagrafeMittente),
        'anagrafeDestinatario': AnagrafeDTOToJSON(value.anagrafeDestinatario),
        'tipiMangime': value.tipiMangime,
        'kgConsegnati': value.kgConsegnati,
    };
}

